/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { LearnVisit } from './LearnVisit';
import {
    LearnVisitFromJSON,
    LearnVisitFromJSONTyped,
    LearnVisitToJSON,
    LearnVisitToJSONTyped,
} from './LearnVisit';

/**
 * 
 * @export
 * @interface CreateLearnVisit201Response
 */
export interface CreateLearnVisit201Response {
    /**
     * 
     */
    visit: LearnVisit;
    /**
     * Send as `X-Learner-Token` on subsequent learner calls.
     */
    visitToken: string;
    /**
     * 
     */
    expiresAt: Date;
}

/**
 * Check if a given object implements the CreateLearnVisit201Response interface.
 */
export function instanceOfCreateLearnVisit201Response(value: object): value is CreateLearnVisit201Response {
    if (!('visit' in value) || value['visit'] === undefined) return false;
    if ((!('visitToken' in (value as Record<string, any>)) && !('visit_token' in (value as Record<string, any>))) || ((value as Record<string, any>)['visitToken'] === undefined && (value as Record<string, any>)['visit_token'] === undefined)) return false;
    if ((!('expiresAt' in (value as Record<string, any>)) && !('expires_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['expiresAt'] === undefined && (value as Record<string, any>)['expires_at'] === undefined)) return false;
    return true;
}

export function CreateLearnVisit201ResponseFromJSON(json: any): CreateLearnVisit201Response {
    return CreateLearnVisit201ResponseFromJSONTyped(json, false);
}

export function CreateLearnVisit201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLearnVisit201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'visit': LearnVisitFromJSON(json['visit']),
        'visitToken': json['visit_token'],
        'expiresAt': (json['expires_at'] == null ? json['expires_at'] : parseDateTime(json['expires_at'])),
    };
}

export function CreateLearnVisit201ResponseToJSON(json: any): CreateLearnVisit201Response {
    return CreateLearnVisit201ResponseToJSONTyped(json, false);
}

export function CreateLearnVisit201ResponseToJSONTyped(value?: CreateLearnVisit201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'visit': LearnVisitToJSON(value['visit']),
        'visit_token': value['visitToken'],
        'expires_at': value['expiresAt'] == null ? value['expiresAt'] : serializeDateTime(value['expiresAt']),
    };
}

